// Single source of truth for legal document versions across all Branon apps.
// Bump these when the lawyer-approved text lands; consent_records rows reference
// these values, so they must change whenever the documents materially change.
export const TOS_VERSION = "2026-07-23"
export const PRIVACY_VERSION = "2026-07-23"
export const LEGAL_LAST_UPDATED = "July 23, 2026"

export const OPERATOR_NAME = "BridgeLinks Enterprises"
export const CONTACT_EMAIL = "bridgelinks2@gmail.com"
